jQuery(document).ready(function ($) {
    $('.bocss-input__date').each(function () {
        const $this = $(this);
        const $minDate = $this.attr('min')? $this.attr('min') : false;
        const $maxDate = $this.attr('max') ? $this.attr('max') : false;
        const $defaultDate = $this.attr('value') ? $this.attr('value') : false;
        const lang = document.getElementsByTagName('html')[0].getAttribute('lang');

        $this.datetimepicker({
            format: 'YYYY-MM-DD',
            pickTime: false,
            useCurrent: false,
            language: lang.substring(0,2),
            ...($defaultDate) && {defaultDate: $defaultDate},
            ...($maxDate) && {maxDate: $maxDate},
            ...($minDate) && {minDate: $minDate}
        });
    });
});
